module.exports = __webpack_public_path__ + "img/bg-post-1.2e0c89eb.png";